
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25.494","height":"24.076","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 451"}},[_c('path',{attrs:{"data-name":"Path 5251","d":"M22.544 1.793c-1.351 0-2.448 1.746-2.448 3.9a4.486 4.486 0 001.385 3.512l-.232 13.08h2.592l-.232-13.08a4.486 4.486 0 001.385-3.512c0-2.152-1.1-3.9-2.45-3.9z"}}),_c('path',{attrs:{"data-name":"Path 5252","d":"M5.255 2.09v3.786a4.354 4.354 0 01-1.344 3.41l.225 12.7H1.619l.225-12.7A4.358 4.358 0 01.5 5.876V2.09m2.5 0v4.68"}}),_c('path',{attrs:{"data-name":"Path 5253","d":"M19.252 21.57a11.536 11.536 0 01-13.01 0M7.385 1.823a11.55 11.55 0 0110.724 0m1.51 15.587a8.72 8.72 0 01-13.744 0M7.657 4.96a8.719 8.719 0 0110.18 0"}})])])
          )
        }
      }
    